// extracted by mini-css-extract-plugin
module.exports = {"WorkFlowContainer":"_1FidS"};